import api from "./api";

// Lista las terapias activas: se usa en la ventana de mantenimiento del periodo
// de terapia para elegir la terapia.
// Las terapias activas. Con todos se devuelve la lista entera: lo piden los
// reportes, donde cortar a 50 dejaria fuera una terapia.
export const getsTerapiasActivas = async (todos = false) => {
    const response = await api.get(`/Terapia/GetsTerapiaResumenViewAll?todos=${todos ? "true" : "false"}`);

    return response.data.data;
}

export const getsTerapiaResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaResumenViewbyIdFilialOrMemberOrTherapist?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&member=' + (filters.member == null ? "" : filters.member)
            + '&therapist=' + (filters.therapist == null ? "" : filters.therapist)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
            + '&idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
        );

    return response.data.data;
}

// Terapias activas de un terapeuta: las elige en el plan de terapia, que se
// lista como "participante - tipo".
export const getsTerapiaResumenViewByTerapeuta = async (idTerapeuta) => {
    const response = await api.get('/Terapia/GetsTerapiaResumenViewByIdTerapeuta?idTerapeuta='
            + (idTerapeuta == null ? 0 : idTerapeuta)
        );

    return response.data.data;
}

export const annulTerapia = (idTerapia) =>
    api.post("/Terapia/AnnulTerapia?idTerapia=" + idTerapia);

export const activeTerapia = (idTerapia) =>
    api.post("/Terapia/ActiveTerapia?idTerapia=" + idTerapia);

export const addUpdateTherapyWithDetails = (dataPost) =>
    api.post("/Terapia/AddUpdateTherapyWithDetails", dataPost);

export const getsTerapiaHorarioView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaHorarioView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaTerapeutaView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaTerapeutaView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaParticipanteView = async (idTerapia) => {
    const response = await api.get("/Terapia/GetsTerapiaParticipanteView?idTerapia=" + idTerapia);

    return response.data.data;
}

export const getsTerapiaPeriodoResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaPeriodoResumenView?'
            + 'idPeriodo=' + (filters.idPeriodo == null ? 0 : filters.idPeriodo)
            + '&idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&participante=' + (filters.participante == null ? "" : filters.participante)
            + '&idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
            + '&terapeuta=' + (filters.terapeuta == null ? "" : filters.terapeuta)
            + '&idEstado=' + (filters.idEstado == null ? 0 : filters.idEstado)
            + '&idTerapiaPeriodo=' + (filters.idTerapiaPeriodo == null ? 0 : filters.idTerapiaPeriodo)
        );

    return response.data.data;
}

// Genera el comprobante de un periodo de terapia que todavia no lo tiene, con el
// concepto de la tarifa y pendiente de pago.
export const generarComprobanteTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/GenerarComprobanteTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

// Registra el pago de un periodo de terapia: crea el pago de periodo si no existe,
// emite el comprobante con el concepto de cobro como item y su detalle de pago.
export const registrarPagoTerapiaPeriodo = (pago) =>
    api.post("/Terapia/RegistrarPagoTerapiaPeriodo", pago);

export const annulTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/AnnulTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const annulDescuentoTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/AnnulDescuentoTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const activeTerapiaPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/ActiveTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const getsTerapiaParticipanteResumenView = async (filters) => {
    const response = await api.get('/Terapia/GetsTerapiaParticipanteResumenView?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&idEstado=' + (filters.idEstado == null ? 0 : filters.idEstado)
        );

    return response.data.data;
}

// Al abrir el periodo se crea el periodo de la terapia y su comprobante con el
// concepto (la tarifa), que queda pendiente de pago.
export const addTerapiaPeriodo = (idPeriodo, idTerapia, numero, idTarifa, idPersona, codigoPeriodo, participante, idDescuento = null, montoDescuento = null, idTerapiaPeriodo = 0) =>
    api.post("/Terapia/AddTerapiaPeriodo", {
        idTerapiaPeriodo: idTerapiaPeriodo || 0,
        idPeriodo,
        idTerapia,
        numero,
        idTarifa,
        idPersona: idPersona == null ? 0 : idPersona,
        codigoPeriodo: codigoPeriodo == null ? "" : codigoPeriodo,
        participante: participante == null ? "" : participante,
        idDescuento: idDescuento != null ? idDescuento : null,
        montoDescuento: montoDescuento != null ? montoDescuento : null,
    });

export const annulPeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/AnnulTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

export const activePeriodo = (idTerapiaPeriodo) =>
    api.post("/Terapia/ActiveTerapiaPeriodo?idTerapiaPeriodo=" + idTerapiaPeriodo);

// Areas guardadas de un plan de terapia. El endpoint es de TerapiaPlan y
// recibe el id del plan (idTerapiaPlan), no el de la terapia.
export const getsTerapiaPlanAreaView = async (idTerapiaPlan) => {
    const response = await api.get("/TerapiaPlan/GetsTerapiaPlanAreaView?idTerapiaPlan=" + idTerapiaPlan);

    return response.data.data;
}
